import { Component, Input, Output, OnDestroy, OnInit, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { NavController } from '@ionic/angular';
import { PopoverService } from '../popover';
import { Subject, takeUntil } from 'rxjs';
import { AppRoutingKeys } from '@shared';
import { SyncService, SyncStatus, SyncStatusEnum } from '@domain/sync';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
	@Input() public headerTitle: string;
	@Input() public headerSubtitle: string;
	@Input() public backBtnEnabled: boolean;
	@Input() public menuBtnEnabled: boolean;
	@Input() public backBtnIconClose: boolean;
	@Input() public searchSortFilterEnabled: boolean;
	@Input() public showSaveBtn: boolean;
	@Input() public saveBtnEnabled: boolean;
	@Input() public exportEnabled: boolean;
	@Input() public ellipsisPopoverEnabled?: boolean;

	@Output() public saveEvent = new EventEmitter<void>();

	public syncStatus: string;

	private workfileId: string;
	private unsubscriber$: Subject<boolean> = new Subject<boolean>();

	public constructor(
		private navController: NavController,
		private popoverService: PopoverService,
		private syncService: SyncService,
		private route: ActivatedRoute,
		private translateService: TranslateService,
		private cd: ChangeDetectorRef
	) {}

	public ngOnInit(): void {
		this.route.paramMap.pipe(takeUntil(this.unsubscriber$)).subscribe((params: ParamMap) => {
			this.workfileId = params.get(AppRoutingKeys.queryParamsMap.workfileId);
		});

		this.syncService.syncStatus$.pipe(takeUntil(this.unsubscriber$)).subscribe((syncStatus: SyncStatus) => {
			switch (syncStatus.status) {
				case SyncStatusEnum.InProgress:
					this.syncStatus = this.translateService.instant('syncStatus.inProgress');
					break;
				case SyncStatusEnum.Synced:
					this.syncStatus = this.translateService.instant('syncStatus.synced', {
						syncDate: syncStatus.date
					});
					break;
				case SyncStatusEnum.Error:
					this.syncStatus = this.translateService.instant('syncStatus.error', {
						syncDate: syncStatus.date
					});
					break;
				default:
					break;
			}
			this.cd.detectChanges();
		});
	}

	public goBack(): void {
		this.navController.pop();
	}

	public openPopover(e: any): void {
		if (!this.exportEnabled) {
			return;
		}

		this.popoverService.presentPopover(e, { workfileId: this.workfileId });
	}

	public async save() {
		if (!this.showSaveBtn) {
			return;
		}

		this.saveEvent.emit();
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next(true);
		this.unsubscriber$.unsubscribe();
	}
}
